export default __webpack_public_path__ + "static/media/deleted.9ba90600.jpg";